export interface IContent {
    id: number;
    type: ContentType;
    title: string;
    loaded:boolean;
    contentUrl: string;
    featuredImage: FeaturedImage;
    location?: any;
    version: number;
    timeStamp: Date|null;
    publishDate: Date|null;
    modifiedDate: Date|null;
    likingEnabled: boolean;
    socialInfoUrl: string;
    commentingEnabled: boolean;
    items: Item[];
    shareLink?: any;
    links?: any;
    fromCache: boolean;
    acknowledgementsEnabled: boolean;
    acknowledgementsType?: any;
    acknowledgementsButtonText?: any;
    externalApiReference?: any;
    autoArchiveDate?: any;
    postFormUrl?: string;
    layout?: string;
    infoModal?: IInfoModal;
}

export interface IInfoModal {
    title: string,
    body: string,
    buttonText: string
}

export interface FeaturedImage {
    height: number;
    width: number;
    url: string;
    fileName: string;
    mediaType: string;
    size: number;
}

export interface Item {
    type: ContentType;
    published?: boolean;
    text?: string; 
    caption?: string;
    description?: string;
    contentUrl?: string;
    image?: Image;
    video?: Video;
    featuredImage?: FeaturedImage|string|null;
    audioFile?: AudioFile;
    file?: File;
    html?: string;
    title?:string;
    contentId?:number;
    webUrl?:string;
}

export interface ContactWidget extends Item {
    country:string,
    email:string,
    mobile:string,
    postalCode:string,
    stateCounty:string,
    subtitle:string,
    telephone:string,
    townCity:string,
    webSite:string,
    address1:string,
    address2:string,
    vcardUrl:string
}

export interface File {
    url: string;
    fileName: string;
    mediaType: string;
    size: number;
}

export interface AudioFile {
    url: string;
    fileName: string;
    mediaType: string;
    size: number;
}

export interface Video {
    url: string;
    fileName: string;
    mediaType: string;
    size: number;
}

export interface Image {
    height: number;
    width: number;
    url: string;
    fileName: string;
    mediaType: string;
    size: number;
}

export enum ContentType {
    page = "page",
    text = "text",
    image = "image",
    video = "video",
    audio = "audio",
    html = "html",
    existing = "existing",
    file = "file",
    link = "link",
    list = "list",
    rss = "rss",
    contact = "contact",
    web = "web",
    default = "default"
}

export const defaultContent:IContent ={
    id: 0,
    type:ContentType.default,
    title: "",
    loaded:false,
    contentUrl: "",
    featuredImage: {
        height: 0,
        width: 0,
        url: "",
        fileName: "",
        mediaType: "",
        size: 0,
    },
    location: null,
    version: 0,
    timeStamp: null,
    publishDate: null,
    modifiedDate: null,
    likingEnabled: false,
    socialInfoUrl: "",
    commentingEnabled: false,
    items: [],
    shareLink: null,
    links: null,
    fromCache: false,
    acknowledgementsEnabled: false,
    acknowledgementsType: null,
    acknowledgementsButtonText: null,
    externalApiReference: null,
    autoArchiveDate: null,
}

export interface SingleContent {
    title:string,
    loaded:boolean,
    type:string
}

export interface Acknowledgement {
    buttonText: string;
    show: boolean;
    status: AcknowledgementStatus;
    type: AcknowledgementType;
    postFormUrl?: string
}

export enum AcknowledgementStatus {
    open = "open",
    closed = "closed",
    completed = "completed",
    noAccess = "noAccess"
}

export enum AcknowledgementType {
    compliancePost = "compliancePost",  
    eventPost = "eventPost",
    competitionPost = "competitionPost"
}